namespace GeniuzPOS.Purchase {
    export enum POTypeFg {
        ItemNormal = 0,
        consign = 1
    }
    Serenity.Decorators.registerEnumType(POTypeFg, 'GeniuzPOS.Purchase.POTypeFg');
}
